// Types
import { UploadIdVerificationHookType } from '../hooks/types/upload-id-verification.hook.type';

const getOCRVERIDASIframeUrlResolver = async (
  url: UploadIdVerificationHookType['url'] = ''
): Promise<[{ url: string }] | [null, true]> => Promise.resolve(url ? [{ url }] : [null, true]);

export { getOCRVERIDASIframeUrlResolver };
